import { useState } from "react";
import { Spinner } from "reactstrap";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "react-toastify";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import { QAPI_URL } from "../../constants/api.constants";
import {
  isGy25TestModule,
  getQapiWinOptions,
  openWindowBeforeRequest,
} from "../../Utilities/moduleHelper";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";

export default function TeacherModuleAnswersAndDocs({
  module,
  answersAvaliable,
  answersFileName,
  titleId = "Answers",
  iconColor,
}) {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);

  const handleOpenAnswers = () => {
    setLoading(true);
    axios
      .get(
        `${API_BASE_URL}/Module/GetModuleAnswers?moduleId=${module.moduleId}`,
        {
          responseType: "blob",
        },
      )
      .then((response) => {
        const fileURL = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = answersFileName || `Facit-${module.moduleId}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(fileURL);
      })
      .catch(async (error) => {
        const responseText = error.response
          ? await error.response.data.text()
          : "";
        if (responseText.trim() === "FileNotFound") {
          toast.warn(
            <FormattedMessage id="Error_Code_Module_Answers_FileNotFound" />,
            TOAST_CONFIG,
          );
        } else {
          toast.warn(formatServiceError(intl, responseText));
        }
      })
      .finally(() => setLoading(false));
  };

  const handleOpenGy25ModuleAnswers = () => {
    const win = openWindowBeforeRequest(intl, getQapiWinOptions());
    if (!win) return;
    setLoading(true);
    axios
      .post("/Course/GetModuleAnswers", {
        qApiId: module.qApiId,
      })
      .then((response) => {
        if (!response.data?.result) {
          win.close();
          toast.warn(<FormattedMessage id="GenericApiError" />, TOAST_CONFIG);
          return;
        }
        const data = JSON.parse(response.data.result);
        win.location.href = `${QAPI_URL}/RT/RT?mode=5&lng=sv`;
        setTimeout(() => {
          win.postMessage({ fun: "init", param: { Data: data } }, "*");
        }, 2000);
      })
      .catch((err) => {
        win.close();
        toast.warn(formatServiceError(intl, err?.response?.data));
      })
      .finally(() => setLoading(false));
  };

  if (!answersAvaliable && module.qApiId == null) {
    return null;
  }

  return (
    <button
      type="button"
      className="module-action-icon"
      style={{ color: iconColor }}
      disabled={loading}
      onClick={
        isGy25TestModule(module)
          ? handleOpenGy25ModuleAnswers
          : handleOpenAnswers
      }
      title={intl.formatMessage({ id: titleId })}
      aria-label={intl.formatMessage({ id: titleId })}
    >
      {loading ? (
        <Spinner size="sm" />
      ) : (
        <span
          className="module-action-icon-mask"
          style={{
            WebkitMaskImage: "url(img/Facit.png)",
            maskImage: "url(img/Facit.png)",
          }}
        />
      )}
    </button>
  );
}
